import { styles } from "../styles";

import ShortTerm from "./our-plans/ShortTerm";
import { SectionWrapper } from "../hoc";

const OurPlans = () => {
  return (
    <div className="">
      <h2 className={`mb-3 ${styles.sectionHeadText} pt-16`}>Our Plans</h2>
      <hr />
      <div className="flex flex-col gap-10">
        {" "}
        <ShortTerm />
        <div className="flex justify-center underline text-lg text-white">
          <a href="/plans">View More</a>
        </div>{" "}
      </div>
    </div>
  );
};

export default SectionWrapper(OurPlans, "our-plans");
